import React, {useRef, useCallback, useState} from 'react';
import muteIcon from '../images/projects/mute.svg';
import volumeIcon from '../images/projects/volume.svg';

const Player = ({track}) => {
	const [mute, setMute] = useState(true);
	const musicRef = useRef()
	const audioStatus = (mute) ? muteIcon : volumeIcon;

	const handleMute = useCallback((status) => {
		if (status) {
			musicRef.current.play()
		} else {
			musicRef.current.pause()
		}
		return setMute(m => !m)
	},[musicRef])

	return (
		<div className="audio-icon player-mode">
			<img className="unselectable" alt="" onClick={() => handleMute(mute)} src={audioStatus} />
			<audio onEnded={() => musicRef.current.play()} ref={musicRef} className="background-music-player" src={track} />
		</div>
	)
}

export default Player